
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as flatpageKORXatw8KVy5sg8SO3DkeasTs_45fTUifMv6mDI_45CzaIwMeta } from "@/pages/flatpage.vue?macro=true";
import { default as payeqI_45fz5tn7n9w2csUe_45iRb6wxDdzve4lSeDezjBs_457EMeta } from "/app/pages/pay.vue?macro=true";
import { default as info0sXbIZ2zwORbDs2yB4R_K0i9_451kxY6WwhHpj_45p9Ki10Meta } from "/app/pages/info.vue?macro=true";
import { default as bonusd9pQc9o4DI36RuYbbAX_v5E6yqJ1slek9YApHleRJcIMeta } from "/app/pages/bonus.vue?macro=true";
import { default as indexndqPXFtP262szLmLJV4PriPTgAg5k_457f05QyTfosBXQMeta } from "/app/pages/index.vue?macro=true";
import { default as loginKGJhNRZhH4FU_45RnHfId5ZCGRhKzPnQPbdAbdNd47TwsMeta } from "/app/pages/login.vue?macro=true";
import { default as halvesuGi8wEy76u1WgojB6ul_gQivTDrfuqFGItFmhgaH24QMeta } from "/app/pages/halves.vue?macro=true";
import { default as paymentdmPKSezhI6Ls0DyrYS8MHdT52WOZHA7vPz_458rflmGnUMeta } from "/app/pages/payment.vue?macro=true";
import { default as sitemapCc4he_452PbvShEh3JaJNYlBjcVwqvYR0QrzHKlC9YKbkMeta } from "/app/pages/sitemap.vue?macro=true";
import { default as make_45wokZwbOqw9a6MpxPf307MUFLHrgjrKwjfAu9WoQro4j0McMeta } from "/app/pages/make-wok.vue?macro=true";
import { default as redirectZSnmzEt2hAANFz3Jo56xqL8ZtM4YP92RdteFcFnDW5gMeta } from "/app/pages/redirect.vue?macro=true";
import { default as indexkpkhE2Zx_45wVJqyj11FyNpnGQQa93xlI5j2_nUvO6G4wMeta } from "/app/pages/news/index.vue?macro=true";
import { default as game_45runnerNoc_zHTFlo66lqNFgihv83jtW_45RI1gd2Ck3s3isNj8MMeta } from "/app/pages/game-runner.vue?macro=true";
import { default as _91slug_93OY1eKGH50IeGHXpXb3BdZRgtgqHXLtURcDbb48n4NVYMeta } from "/app/pages/news/[slug].vue?macro=true";
import { default as indexs5FGziCfduMusRE41M8OROCL2YtiB2DJQpb7nLUfv9EMeta } from "/app/pages/sales/index.vue?macro=true";
import { default as indexpxl3THrl4_45pjTVfsjniq3i35WkclytpQgJFI4Amo4OoMeta } from "/app/pages/basket/index.vue?macro=true";
import { default as _91slug_936MCqY4FgTBrwFszxCpgeeRTG_45wVkg_pun1ApjsWYg_MMeta } from "/app/pages/sales/[slug].vue?macro=true";
import { default as slot_45machiney7HJ52GzbrxI6WtVQkjotWPUGxdgpVU6Cr_451Mmvg1eAMeta } from "/app/pages/slot-machine.vue?macro=true";
import { default as cardsWsUSQEzuQBZHiDglriXMCSAJAHB0oMSA24EGpe9ZqJ0Meta } from "/app/pages/profile/cards.vue?macro=true";
import { default as indexPYMehh1H3I51I_Jt_45B2w91jhAIWvwCrr7OI55V5sjLcMeta } from "/app/pages/profile/index.vue?macro=true";
import { default as indexCeqxVKpSAu8C9ByvInux8B2G_Bf95beyproRHcZ5mwkMeta } from "/app/pages/delivery/index.vue?macro=true";
import { default as _91slug_93DOY1ZHoKj7G_0Ibmx9vtFc_Q6Kj8bJJj_45FExpHe87fAMeta } from "/app/pages/delivery/[slug].vue?macro=true";
import { default as settingsd4_45MiyAPiyy7jAlhaX9bdhhDnO9k2pBltk1j4sr2A9YMeta } from "/app/pages/profile/settings.vue?macro=true";
import { default as promocodesyCti2WxsxerlyXyE501yS7OLNlwkMGCxoDfirStOMs8Meta } from "/app/pages/profile/promocodes.vue?macro=true";
import { default as _91id_93JuDCrh_MmZ1AjqFz_45vusa_RjnGxCzZJr_45Czz1f8LwnoMeta } from "/app/pages/profile/orders/[id].vue?macro=true";
import { default as indexAlhM6oLA96OKGe7TuSwYKV5NVaigu5NMX6KOAzs1LSgMeta } from "/app/pages/sales/archive/index.vue?macro=true";
import { default as indexyOnL9pdYWnFsOEGv2h_CpEYaN91JmGd9LnnepNn0tLgMeta } from "/app/pages/profile/orders/index.vue?macro=true";
import { default as _91slug_938OrDV_45GgGSwSHpvaiqL2MwIknNzt1Z6GnAu5ShhWxC8Meta } from "/app/pages/sales/archive/[slug].vue?macro=true";
import { default as bonus_45historyxijg10c44_456bsmtjnYqsMJI8xOi4iEQtj5TEukUncD4Meta } from "/app/pages/profile/bonus-history.vue?macro=true";
import { default as notificationso7ihmTprjYVYKwDPlmFW4PmmlP47tNkcBDtHUFBPVrUMeta } from "/app/pages/profile/notifications.vue?macro=true";
import { default as indexh2HReoV1hCUTxbQ0KR8uS_51CrvTM2bu1tnJFgCnxREMeta } from "/app/pages/product/[product]/index.vue?macro=true";
import { default as password_45change3_45Yo2CwnECKV1iyFsup45lPEvrJI_zaxD6s9AKFrfSYMeta } from "/app/pages/profile/password-change.vue?macro=true";
import { default as indexJwZ_452rUHnTB5dOyaxUTTh7WS_45n5JRKeCkaWYK1Ocz5gMeta } from "/app/pages/category/[category]/index.vue?macro=true";
import { default as index96poGCu_jgRiuKgIHgJ4NEhdRHAS2R77YMNVzTSBHYIMeta } from "/app/pages/[categories]/[product]/index.vue?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js?macro=true";
import { default as component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA } from "/app/node_modules/nuxt/dist/pages/runtime/component-stub.js";
export default [
  {
    name: "about",
    path: "/about/",
    meta: {"layout":"default"},
    component: () => import("@/pages/flatpage.vue")
  },
  {
    name: "terms_of_use",
    path: "/terms_of_use/",
    meta: {"layout":"default"},
    component: () => import("@/pages/flatpage.vue")
  },
  {
    name: "confidential",
    path: "/confidential/",
    meta: {"layout":"default"},
    component: () => import("@/pages/flatpage.vue")
  },
  {
    name: "important/",
    path: "/important/",
    meta: {"layout":"default"},
    component: () => import("@/pages/flatpage.vue")
  },
  {
    name: "rules/",
    path: "/rules/",
    meta: {"layout":"default"},
    component: () => import("@/pages/flatpage.vue")
  },
  {
    name: "pay",
    path: "/pay",
    meta: payeqI_45fz5tn7n9w2csUe_45iRb6wxDdzve4lSeDezjBs_457EMeta || {},
    component: () => import("/app/pages/pay.vue")
  },
  {
    name: "info",
    path: "/info",
    component: () => import("/app/pages/info.vue")
  },
  {
    name: "bonus",
    path: "/bonus",
    component: () => import("/app/pages/bonus.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/app/pages/index.vue")
  },
  {
    name: "login",
    path: "/login",
    component: () => import("/app/pages/login.vue")
  },
  {
    name: "halves",
    path: "/halves",
    component: () => import("/app/pages/halves.vue")
  },
  {
    name: "payment",
    path: "/payment",
    component: () => import("/app/pages/payment.vue")
  },
  {
    name: "sitemap",
    path: "/sitemap",
    component: () => import("/app/pages/sitemap.vue")
  },
  {
    name: "make-wok",
    path: "/make-wok",
    component: () => import("/app/pages/make-wok.vue")
  },
  {
    name: "redirect",
    path: "/redirect",
    component: () => import("/app/pages/redirect.vue")
  },
  {
    name: "news",
    path: "/news",
    component: () => import("/app/pages/news/index.vue")
  },
  {
    name: "game-runner",
    path: "/game-runner",
    meta: game_45runnerNoc_zHTFlo66lqNFgihv83jtW_45RI1gd2Ck3s3isNj8MMeta || {},
    component: () => import("/app/pages/game-runner.vue")
  },
  {
    name: "news-slug",
    path: "/news/:slug()",
    component: () => import("/app/pages/news/[slug].vue")
  },
  {
    name: "sales",
    path: "/sales",
    component: () => import("/app/pages/sales/index.vue")
  },
  {
    name: "basket",
    path: "/basket",
    component: () => import("/app/pages/basket/index.vue")
  },
  {
    name: "sales-slug",
    path: "/sales/:slug()",
    component: () => import("/app/pages/sales/[slug].vue")
  },
  {
    name: "slot-machine",
    path: "/slot-machine",
    component: () => import("/app/pages/slot-machine.vue")
  },
  {
    name: "profile-cards",
    path: "/profile/cards",
    component: () => import("/app/pages/profile/cards.vue")
  },
  {
    name: "profile",
    path: "/profile",
    component: () => import("/app/pages/profile/index.vue")
  },
  {
    name: "delivery",
    path: "/delivery",
    component: () => import("/app/pages/delivery/index.vue")
  },
  {
    name: "delivery-slug",
    path: "/delivery/:slug()",
    component: () => import("/app/pages/delivery/[slug].vue")
  },
  {
    name: "profile-settings",
    path: "/profile/settings",
    component: () => import("/app/pages/profile/settings.vue")
  },
  {
    name: "profile-promocodes",
    path: "/profile/promocodes",
    component: () => import("/app/pages/profile/promocodes.vue")
  },
  {
    name: "profile-orders-id",
    path: "/profile/orders/:id()",
    meta: _91id_93JuDCrh_MmZ1AjqFz_45vusa_RjnGxCzZJr_45Czz1f8LwnoMeta || {},
    component: () => import("/app/pages/profile/orders/[id].vue")
  },
  {
    name: "sales-archive",
    path: "/sales/archive",
    component: () => import("/app/pages/sales/archive/index.vue")
  },
  {
    name: "profile-orders",
    path: "/profile/orders",
    component: () => import("/app/pages/profile/orders/index.vue")
  },
  {
    name: "sales-archive-slug",
    path: "/sales/archive/:slug()",
    component: () => import("/app/pages/sales/archive/[slug].vue")
  },
  {
    name: "profile-bonus-history",
    path: "/profile/bonus-history",
    component: () => import("/app/pages/profile/bonus-history.vue")
  },
  {
    name: "profile-notifications",
    path: "/profile/notifications",
    component: () => import("/app/pages/profile/notifications.vue")
  },
  {
    name: "product-product",
    path: "/product/:product()",
    component: () => import("/app/pages/product/[product]/index.vue")
  },
  {
    name: "profile-password-change",
    path: "/profile/password-change",
    component: () => import("/app/pages/profile/password-change.vue")
  },
  {
    name: "category-category",
    path: "/category/:category()",
    meta: indexJwZ_452rUHnTB5dOyaxUTTh7WS_45n5JRKeCkaWYK1Ocz5gMeta || {},
    component: () => import("/app/pages/category/[category]/index.vue")
  },
  {
    name: "categories-product",
    path: "/:categories()/:product()",
    component: () => import("/app/pages/[categories]/[product]/index.vue")
  },
  {
    name: "filter-category-category",
    path: "/category/filter/:category()",
    meta: indexJwZ_452rUHnTB5dOyaxUTTh7WS_45n5JRKeCkaWYK1Ocz5gMeta || {},
    component: () => import("/app/pages/category/[category]/index.vue")
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/category",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  },
  {
    name: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIAMeta?.name,
    path: "/product",
    component: component_45stubbjLkcGu196H3H6U3AGpzju91fOJPpk9xx3zVsuzjgIA
  }
]